import {Component, ViewChild} from "@angular/core";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {PriceLevelSearchPageComponent} from "../price-level-search-page/price-level-search-page.component";

export class PriceLevelReportSelectionData extends EntityData<PriceLevelReportSelectionData> {
    @identifier priceLevelId: number;
    @field name: string;
}

@Component({
    selector: "wbo-price-level-report-selection",
    templateUrl: "./price-level-report-selection-control.component.html"
})
export class PriceLevelReportSelectionControlComponent {

    PriceLevelSearchPageComponent = PriceLevelSearchPageComponent;

    fieldName: string = "priceLevels";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromPriceLevel(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((pricelevel: any) => pricelevel.priceLevelId === item.priceLevelId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
